import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { AppContextProps } from './types';
import INITIAL_STATE from './state';
import ReducerHelpers from './reducer-helpers';
import reducerWithPersistence from './reducers';

export const storeContext = createContext<AppContextProps>({
    state: INITIAL_STATE,
    dispatch: () => null,
});

const { Provider } = storeContext;

interface AppProviderProps {
    children: ReactNode;
}

const AppProvider = ({ children }: AppProviderProps) => {
    const [state, dispatch] = useReducer(
        reducerWithPersistence,
        INITIAL_STATE,
        ReducerHelpers.stateInitializer
    );
    return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

const useStateValue = () => useContext(storeContext);

export { AppProvider, useStateValue };
